export enum AuthTypes {
  POST_AUTH_LOGIN = '[AUTH] POST_AUTH_LOGIN',
  POST_AUTH_LOGIN_CANCEL = '[AUTH] POST_AUTH_LOGIN_CANCEL',
  POST_AUTH_LOGIN_SUCCESS = '[AUTH] POST_AUTH_LOGIN_SUCCESS',

  POST_AUTH_LOGOUT = '[AUTH] POST_AUTH_LOGOUT',
  POST_AUTH_LOGOUT_SUCCESS = '[AUTH] POST_AUTH_LOGOUT_SUCCESS',

  GET_COMPANY_DETAILS = '[AUTH] GET_COMPANY_DETAILS',
  GET_COMPANY_DETAILS_SUCCESS = '[AUTH] GET_COMPANY_DETAILS_SUCCESS',

  GET_COMPANY_KIOSK_SETTINGS = '[AUTH] GET_COMPANY_KIOSK_SETTINGS',
  GET_COMPANY_KIOSK_SETTINGS_SUCCESS = '[AUTH] GET_COMPANY_KIOSK_SETTINGS_SUCCESS',
}
